<template>
  <div>
    <NavMenu />

    <div class="page-content">

      <div v-if="busy"><BusySpinner /></div>

      <div v-else>

        <div class="searchbox">
          <input type="text" placeholder="Link, UID, or Email" v-model="query" v-on:keypress.enter="doSearch" />
          <button v-on:click="doSearch">Search</button>
        </div>

        <div v-if="showSummary" class="summary">
          <span>Total Packages: {{linkCount}}</span>
          <span>Sort By: 
          <select v-model="sortBy">
            <option>Date</option>
            <option>Title</option>
            <option>Downloads</option>
          </select></span>

        </div>

<!-- 

    amVersionCode: number,
    amVersionString: string,
    amPlatform: "android" | "ios",
    amPackageVersion: string,
    requiredEffects: string[] | null,
    maxFFVer: number | null,
    title: string | null,
    largeThumbUrl: string | null,
    medThumbUrl: string | null,
    smallThumbUrl: string | null,
    tinyThumbUrl: string | null,
    amPackageId: string | null,
    shareDate: admin.firestore.Timestamp,
    size: number,
    projects: SharedProjectInfo[],
    litePackage: LitePackageInfo,
    downloads: number,
    ownerDownloads: number,
    liteDownloads: number,
    likes: number


-->
        <div class="linkinfo" v-for="link in sortedLinks" :key="link.link">
          <div class="left">
            <img class="thumb" v-bind:src="link.info.tinyThumbUrl" />
            <img class="qrcode" v-bind:src="link.qrcode" />
          </div>
          <div class="right">
            <h1>{{link.info.title}}</h1>
            <table>
                <tr><td>Project Version</td><td>{{link.info.maxFFVer}}</td></tr>
                <tr><td>Actions</td><td>
                  <a target="_blank" v-bind:href="link.downloadUrl">Download Package ZIP</a><br />
                  <span v-if="link.info.litePackage.status=='exists'" ><a target="_blank" v-bind:href="link.liteDownloadUrl">Download Lite ZIP</a><br /></span>
                  <a target="_blank" v-bind:href="link.metaDownloadUrl">Download Meta JSON</a>
                  </td></tr>
                <tr><td>Sharing User</td><td>
                  <router-link v-bind:to="link.userLink"><span class="fixed"><span v-for="p in link.uidParts" :key="p">{{p}}</span></span></router-link>
                  </td></tr>
                <tr><td>Share Date</td><td>{{link.shareDateFormatted}}</td></tr>
                <tr><td>Package ID</td><td>{{link.pid}}</td></tr>
                <tr><td>Size</td><td>{{link.sizeFormatted}}</td></tr>
                <tr><td>Lite Package</td><td>{{link.liteInfo}}</td></tr>
                <tr><td>Link</td><td class="fulllink"><a v-bind:href="link.link">{{link.link}}</a></td></tr>
                <tr><td>Large Thumb</td><td class="fulllink"><a v-bind:href="link.info.largeThumbUrl">{{link.info.largeThumbUrl}}</a></td></tr>
                <tr><td>Med Thumb</td><td class="fulllink"><a v-bind:href="link.info.medThumbUrl">{{link.info.medThumbUrl}}</a></td></tr>
                <tr><td>Small Thumb</td><td class="fulllink"><a v-bind:href="link.info.smallThumbUrl">{{link.info.smallThumbUrl}}</a></td></tr>
                <tr><td>Tiny Thumb</td><td class="fulllink"><a v-bind:href="link.info.tinyThumbUrl">{{link.info.tinyThumbUrl}}</a></td></tr>
                <tr><td>Downloads</td><td class="tagged"><span>Total</span>{{link.info.downloads}} <span>Owner</span>{{link.info.ownerDownloads}} <span>Lite</span>{{link.info.liteDownloads}}</td></tr>
                <tr><td>App Version</td><td class="tagged"><span>Build</span>{{link.info.amVersionString}} ({{link.info.amVersionCode}}) <span>App</span>{{link.info.amPackageId}} / {{link.info.amPackageVersion}} <span>Platform</span>{{link.platform}}</td></tr>
                <tr><td>Contents</td><td>
                    <div v-for="project in link.info.projects" :key="project.title">
                      {{project.title}} ({{project.formattedSize}} {{project.formattedType}})
                    </div>
                  </td></tr>
                <tr><td>Required Effects</td><td>
                  <div v-for="effect in link.info.requiredEffects" :key="effect">{{effect}}</div>
                  </td></tr>
            </table>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'
import BusySpinner from '@/components/BusySpinner.vue'
import QRCode from 'qrcode'

import firebase from 'firebase/app'
import 'firebase/functions'

let adminGetLinkInfo = firebase.functions().httpsCallable('adminGetLinkInfo')

let dateFormat = Intl.DateTimeFormat(undefined,{
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
  timeZone: 'Asia/Seoul',
  timeZoneName: "short"
})

function formatDecimal(v) {
    return v.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function formatByteSize(size) {
    if( size > 1024 * 1024 * 1024 * 1024 ) {
        return formatDecimal(size / (1024.0 * 1024 * 1024 * 1024)) + " TB";
    } else if( size > 1024 * 1024 * 1024 ) {
        return formatDecimal(size / (1024.0 * 1024 * 1024)) + " GB";
    } else if( size > 1024 * 1024 ) {
        return formatDecimal(size / (1024.0 * 1024)) + " MB";
    } else if( size > 1024 ) {
        return formatDecimal(size / 1024.0) + " kb";
    } else {
        return size + " bytes"
    }
}

function formatDate(d) {
  let dd;
  if( d && d._seconds ) {
    dd = new Date(d._seconds * 1000)
  } else if ( d && d.seconds ) {
    dd = new Date(d.seconds * 1000)
  } else {
    dd = new Date(d)
  }
  return dateFormat.format(dd)
}

function epochDate(d) {
  let dd;
  if( d && d._seconds ) {
    dd = new Date(d._seconds * 1000)
  } else if ( d && d.seconds ) {
    dd = new Date(d.seconds * 1000)
  } else {
    dd = new Date(d)
  }
  return dd.getTime()
}

export default {
  name: 'Links',
  components: { NavMenu, BusySpinner },
  data: ()=>({
    busy: false,
    query: "",
    resultQuery: "",
    showSummary: false,
    sortBy: "Date",
    linkCount: 0,
    links: []
  }),
  beforeRouteUpdate (to, from, next) {
    let routeUid = to.params.uid;
    let routePid = to.params.pid;
    let query = routeUid && routePid ? `/u/${routeUid}/p/${routePid}/` : routeUid && !routePid ? `${routeUid}` : ""
    if( query != this.resultQuery ) {
      this.executeQuery(query)
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm=>{
      let routeUid = to.params.uid;
      let routePid = to.params.pid;
      let query = routeUid && routePid ? `/u/${routeUid}/p/${routePid}/` : routeUid && !routePid ? `${routeUid}` : ""
      if( query != vm.resultQuery ) {
        vm.executeQuery(query)
      }
    })
  },
  computed: {
    sortedLinks() {
      if( this.sortBy == "Date" ) {
        return [...this.links].sort((a,b)=>epochDate(b.info.shareDate)-epochDate(a.info.shareDate));
      } else if( this.sortBy == "Title") {
        return [...this.links].sort((a,b)=>{
          if( a.info.title < b.info.title )
            return -1
          else if( a.info.title > b.info.title )
            return 1
          else
            return 0
        });
      } else if( this.sortBy == "Downloads") {
        return [...this.links].sort((a,b)=>(b.info.downloads ?? 0)-(a.info.downloads ?? 0));
      } else {
        return [...this.links];
      }
    }
  },
  methods: {
    doSearch() {
      this.executeQuery(this.query);
    },
    executeQuery(query) {
      var page = this;
      page.busy = true;
      page.showSummary = false;
      page.links = [];
      if(query) {
        adminGetLinkInfo({link: query}).then(async function(result){
          page.busy = false
          console.log("RESULT",result.data)
          if( result.data.status == "success") {
            page.resultQuery = query
            page.showSummary = true
            let uid = result.data.links.length > 0 ? result.data.links[0].uid : ""
            let pid = result.data.links.length == 1 ? result.data.links[0].pid : ""
            if( uid && pid && (page.$route.params.uid != uid || page.$route.params.pid != pid)) {
              page.$router.push({name:"Links", params:{uid: uid, pid: pid}})
            } else if( uid && !pid && (page.$route.params.uid != uid || page.$route.params.pid != pid)) {
              page.$router.push({name:"Links", params:{uid: uid}})
            }
            let links = result.data.links.sort((a,b)=>epochDate(b.info.shareDate)-epochDate(a.info.shareDate));
            page.linkCount = links.length;
            let qrcount = 0;
            for( let it of links ) {
              if( qrcount < 100 || it.downloads > 30 ) {
                console.log(`Make QR code for: ${it.link}`)
                it.qrcode = await QRCode.toDataURL(it.link)
                console.log(`Done making QR code for: ${it.link}`)
                qrcount++
              } else {
                it.qrcode = ""
              }

              it.uidParts = it.uid.match(/.{1,7}/g)
              it.userLink = `/user/${it.uid}`
              it.shareDateFormatted = formatDate(it.info.shareDate)
              it.sizeFormatted = formatByteSize(it.info.size)
              it.downloadUrl = it.rawLink.includes("?") ? it.rawLink + "&asset=package" : it.rawLink + "?asset=package"
              it.liteDownloadUrl = it.rawLink.includes("?") ? it.rawLink + "&asset=litepackage" : it.rawLink + "?asset=litepackage"
              it.metaDownloadUrl = it.rawLink.includes("?") ? it.rawLink + "&asset=meta" : it.rawLink + "?asset=meta"
              it.platform = it.info.amPlatform == "android" ? "Android" : it.info.amPlatform == "ios" ? "iOS" : !it.info.amPlatform ? "Unknown" : it.info.amPlatform
              if( !it.info.litePackage ) {
                it.info.litePackage = {
                  status: "(no data)",
                  processingAttempts: 0,
                  size: 0,
                  processingStarted: 0,
                  processingFinished: 0
                }
              }
              it.liteInfo = (
                !it.info.litePackage ? "(no data)" :
                it.info.litePackage.status == "none" ? "None" :
                it.info.litePackage.status == "exists" ? `Exists: ${formatByteSize(it.info.litePackage.size)} (${it.info.litePackage.processingAttempts ? "" + it.info.litePackage.processingAttempts + " attempts; " : "" }processing took ${(it.info.litePackage.processingFinished - it.info.litePackage.processingStarted)/1000} seconds)` :
                it.info.litePackage.status == "processing" ? `Processing (started ${formatDate(it.info.litePackage.processingStarted)}; ${it.info.litePackage.processingAttempts ?? 0} attempts)` :
                it.info.litePackage.status == "failed" ? `Failed: ${it.info.litePackage.failureReason}` :
                it.info.litePackage.status
              )
              console.log(`Done adding info for: ${it.link}`)
            }
            // let linkPromises = (await Promise.all(
            //   linkList.map(async it=>({...it, qrcode: await QRCode.toDataURL(it.link)}))
            //   ))
            // console.log("Links 0", linkList)
            // let links = linkList.map(it=>({...it, 
            //     uidParts: it.uid.match(/.{1,7}/g), 
            //     userLink: `/user/${it.uid}`, 
            //     shareDateFormatted: formatDate(it.info.shareDate),
            //     sizeFormatted: formatByteSize(it.info.size),
            //     downloadUrl: it.rawLink.includes("?") ? it.rawLink + "&asset=package" : it.rawLink + "?asset=package",
            //     liteDownloadUrl: it.rawLink.includes("?") ? it.rawLink + "&asset=litepackage" : it.rawLink + "?asset=litepackage",
            //     metaDownloadUrl: it.rawLink.includes("?") ? it.rawLink + "&asset=meta" : it.rawLink + "?asset=meta",
            //     platform: it.info.amPlatform == "android" ? "Android" : it.info.amPlatform == "ios" ? "iOS" : !it.info.amPlatform ? "Unknown" : it.info.amPlatform,
            //     liteInfo: 
            //       it.info.litePackage.status == "none" ? "None" :
            //       it.info.litePackage.status == "exists" ? `Exists: ${formatByteSize(it.info.litePackage.size)} (${it.info.litePackage.processingAttempts ? "" + it.info.litePackage.processingAttempts + " attempts; " : "" }processing took ${(it.info.litePackage.processingFinished - it.info.litePackage.processingStarted)/1000} seconds)` :
            //       it.info.litePackage.status == "processing" ? `Processing (started ${formatDate(it.info.litePackage.processingStarted)}; ${it.info.litePackage.processingAttempts ?? 0} attempts)` :
            //       it.info.litePackage.status == "failed" ? `Failed: ${it.info.litePackage.failureReason}` :
            //       it.info.litePackage.status
            //     }))
            console.log("Links 1", links)
            for( let link of links ) {
              link.info.projects = link.info.projects.map(it=>({...it, formattedSize: formatByteSize(it.size), formattedType:(
                it.type == "scene" ? "Project" :
                it.type == "element" ? "Element" :
                it.type
              )}))
            }
            console.log("Links 2", links)
            page.links = links
          }
        }).catch(function(/*error*/){
          page.busy = false
        })
      } else {
        page.busy = false;
      }
    }

  }
}
</script>

<style lang="scss" scoped>

.searchbox {
  border-bottom: 1px solid #AAA;
  padding-left: 10pt;
  padding-right: 10pt;
  padding-bottom: 8pt;
  margin-left: -10pt;
  margin-right: -10pt;

  input {
    width: calc( 100% - 90pt );
    font-size: 13pt;
    border: 1px solid #BBB;
    border-radius: 2pt;
    padding: 3pt;
  }

  input:focus-visible {
    border: 2px solid rgb(116, 114, 148);
  }

  input::placeholder {
    color: #BBB;
  }

  button {
    font-size: 12pt;
    width: 60pt;
    margin-left: 5pt;
    padding: 3pt;
  }
}

.summary {
  margin-top: 5pt;
  margin-bottom: 5pt;
  margin-left: 0pt;
  margin-right: 0pt;
  padding: 5pt;
  border-radius: 3pt;
  font-size: 10pt;

  background: #F0F0F5;

  span {
    display: inline-block;
    margin-right: 20pt;
  }

  select {
    border: none;
    padding: 2pt;
    border-radius: 2pt;
  }
}

.linkinfo {

  display: flex;
  flex-direction: row;
  margin-top: 20pt;
  // border-top: 1px solid #DDD;
  border-bottom: 2px solid #DDD;
  padding-top: 15pt;
  padding-bottom: 20pt;

  .left {

    padding-left: 8pt;
    padding-right: 8pt;

    .thumb {
      display: block;
      width: 70pt;
      height: 70pt;
      margin: 5pt;
      border-radius: 3pt;
    }

    .qrcode {
      display: block;
      width: 80pt;
      height: 80pt;
    }

  }

  .right {
    

    h1 { 
      font-size: 13pt;
      margin-top: 2pt;
      margin-bottom: 2pt;
    }

    table {
      border-collapse: collapse;

      td { 
        vertical-align: top; 
        font-size: 10pt;
        padding-top: 6pt;
      }

      td:first-of-type { 
        width: 70pt;
        color: #888; 
        font-size: 8pt;
        padding-top: 7pt;
      }

      .fulllink {
        a {
          display: inline-block;
          font-size: 8pt;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 350pt;
        }
      }

      .tagged {
        span {
          display: inline-block;
          font-size: 7pt;
          text-transform: uppercase;
          color: #AAA;
          padding-right: 4pt;
          padding-left: 8pt;
        }

        span:first-of-type {
          padding-left: 0pt;
        }
      }

    }

  }

}

.fixed {
  font-family: 'Courier New', Courier, monospace;
  span {
    display: inline-block;
    margin-right: 5pt;
  }
}


</style>
